import { TEqualityFunction } from '@core/js/store/types';

import { TPostCodeFinderState } from '@interlayer/js/app/store/reducers/postCodeFinder/types';
import { TPostCodeSelector } from '@interlayer/js/app/store/types';

import { REDUCER_NAMES } from '../constants';

import { useCustomSelector } from './useCustomSelector';

export const usePostCodeSelector = <TSelected = TPostCodeFinderState>(
    selector?: TPostCodeSelector<TSelected>,
    equalityFn?: TEqualityFunction<TSelected>
) => useCustomSelector<TSelected, typeof REDUCER_NAMES.postCode>(REDUCER_NAMES.postCode, selector, equalityFn);
